/* eslint-disable react/prop-types,react/no-array-index-key,react/prefer-stateless-function */
import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

const HelpNav = props => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#panelGroupMenu_c_7`).collapse(props.isOpen ? 'show' : 'hide');
  }, [props.isOpen]);

  return (
    <div className="panel panel-default">
      <div className="panel-heading" role="tab" id="panelGroupMenu_h_7">
        <a
          className="dropdown-toggle dropdown-toggle-collapse collapsed"
          role="button"
          data-toggle="collapse"
          data-parent="#panelGroupMenu"
          href={null}
          aria-expanded="false"
          aria-controls="panelGroupMenu_c_7"
          title={t('Помощь')}
          onClick={props.onToggle}
        >
          <i className="fa fa-question-circle fa-lg fa-fw" aria-hidden="true" />{' '}
          {t('Помощь')}
        </a>
      </div>
      <div
        id="panelGroupMenu_c_7"
        className={'panel-collapse collapse'}
        role="tabpanel"
        aria-labelledby="panelGroupMenu_h_7"
      >
        <div className="list-group">
          <NavLink
            to="/help/reference-information"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">{t('Справка')}</span>
          </NavLink>
          <PopUpLink className="list-group-item" hashName="feedback">
            <span className="list-group-item-val">{t('Обратная связь')}</span>
          </PopUpLink>
        </div>
      </div>
    </div>
  );
};

HelpNav.defaultProps = {
  isOpen: false,
  onToggle: () => {}
};

HelpNav.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func
};

export default HelpNav;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Sidebar/Navs/HelpNav.js